<template>
  <div class="coupon-container">
    <!--进度条 -->
    <div class="coupon-step">
      <div class="coupon-step-num">
        <div v-for="(item, index) in couponList" :key="index">
          <div class="coupon-num-text">{{ item.num }}</div>
          <div class="coupon-num-explain">积分抵扣券</div>
        </div>
      </div>

      <div class="coupon-step-row">
        <div
          class="coupon-step-active"
          :style="{ width: stepActive * 10 + '%' }"
        ></div>
      </div>

      <div class="coupon-step-times">
        <div v-for="(item, index) in couponList" :key="index">
          <div class="coupon-num-explain" style="margin-bottom: 2px">
            完成抽奖
          </div>
          <div class="coupon-num-text">{{ item.times }}次</div>
        </div>
      </div>
    </div>

    <!-- 卡券列表 -->
    <div class="coupon-list">
      <div
        class="coupon-list-row"
        v-for="(item, index) in couponList"
        :key="index"
      >
        <div class="coupon-list-card">
          <div class="list-card-num">{{ item.num }}</div>
          <div class="list-card-text">积分</div>
        </div>
        <div class="coupon-list-use">
          <div style="font-size: 16px">单笔订单</div>
          <div style="font-size: 10px; margin-top: 5px">
            满{{ item.use }}使用
          </div>
        </div>
        <div class="coupon-list-btn">
          <div
            class="list-btn-box"
            :class="{ 'list-btn-able': item.status === 1, 'list-btn-ed': item.status === 2 }"
            @click="takeCoupon(item, index)"
          >
            {{ getBtnText(item.status) }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import activityApi from '../../../api/activity'

export default {
  name: 'TurntableCoupon',
  props: {
    lotteryTimes: {
      type: Number,
      default: 0
    },
    tookCouponList: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      couponList: [
        {
          num: 1888,
          times: 8,
          use: 8888,
          status: 0,
          code: '2020ANNUAL01'
        },
        {
          num: 2888,
          times: 18,
          use: 8888,
          status: 0,
          code: '2020ANNUAL02'
        },
        {
          num: 3888,
          times: 28,
          use: 8888,
          status: 0,
          code: '2020ANNUAL03'
        },
        {
          num: 18888,
          times: 38,
          use: 88888,
          status: 0,
          code: '2020ANNUAL04'
        },
        {
          num: 28888,
          times: 48,
          use: 88888,
          status: 0,
          code: '2020ANNUAL05'
        }
      ],
      stepActive: 0
    }
  },
  watch: {
    lotteryTimes (val) {
      if (val >= 8 && val < 18) {
        this.stepActive = 1
      } else if (val >= 18 && val < 28) {
        this.stepActive = 3
      } else if (val >= 28 && val < 38) {
        this.stepActive = 5
      } else if (val >= 38 && val < 48) {
        this.stepActive = 7
      } else if (val >= 48) {
        this.stepActive = 9
      }
      if (this.stepActive) {
        this.setCouponStatus(this.stepActive)
      }
      return val
    },

    tookCouponList (val) {
      if (!val.length) {
        return
      }
      this.couponList.forEach(item => {
        val.forEach(itm => {
          if (item.code === itm.couponDefineCode) {
            item.status = 2
          }
        })
      })
    }
  },

  methods: {
    getBtnText (val) {
      let text = ''
      if (!val) {
        text = '未达标'
      } else if (val === 1) {
        text = '点击领取'
      } else {
        text = '已领取'
      }
      return text
    },

    setCouponStatus (index) {
      for (let i = 0; i < (index + 1) / 2; i++) {
        if (this.couponList[i].status === 2) {
          continue
        }
        this.couponList[i].status = 1
      }
    },

    // 领取卡券
    takeCoupon (item, index) {
      if (item.status !== 1) {
        return
      }
      let data = {
        couponDefineCode: item.code
      }
      activityApi.takeCoupon(data).then(res => {
        if (res.data.resultCode === '0') {
          this.couponList[index].status = 2
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.coupon-container {
  padding: 0 15px;

  .coupon-step {
    .coupon-step-num,
    .coupon-step-times {
      display: flex;
      justify-content: space-around;
      // padding: 0 10px;

      & > div {
        text-align: center;
      }

      .coupon-num-text {
        font-size: 14px;
        margin-bottom: 2px;
      }

      .coupon-num-explain {
        font-size: 10px;
      }
    }

    .coupon-step-row {
      width: 100%;
      height: 6px;
      margin: 12px 0;
      border-radius: 6px;
      background-color: #76b3bd;

      .coupon-step-active {
        height: 6px;
        border-radius: 6px;
        background-color: #de412b;
      }
    }
  }

  .coupon-list {
    margin-top: 25px;

    .coupon-list-row {
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-top: 0.5px solid #76b3bd;
      padding: 20px 10px;

      .coupon-list-card {
        height: 50px;
        width: 109px;
        position: relative;
        background: url("../../../assets/images/activity/turntable/coupon.png")
          no-repeat;
        background-size: 100%;
        box-sizing: border-box;
        text-align: center;
        padding-right: 20px;
        padding-top: 6px;

        .list-card-num {
          font-size: 20px;
          font-weight: bold;
        }

        .list-card-text {
          font-size: 12px;
        }
      }
    }
  }

  .list-btn-box {
    height: 28px;
    width: 70px;
    line-height: 28px;
    text-align: center;
    font-size: 12px;
    border-radius: 6px;
    border: 0.5px solid #fff;
    box-sizing: border-box;
  }

  .list-btn-able {
    background-color: #de412b;
    border-color: #de412b;
  }

  .list-btn-ed {
    background-color: #76b3bd;
    border-color: #76b3bd;
  }
}
</style>
